import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getCategories, getProducts } from "@/lib/api";
import { CategoryChips } from "@/components/CategoryChips";
import { ProductCard } from "@/components/ProductCard";

export const ShopPage = () => {
  const [params, setParams] = useSearchParams();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const active = params.get("category") || "all";

  useEffect(() => { getCategories().then(setCategories); }, []);
  useEffect(() => {
    getProducts(active === "all" ? {} : { category: active }).then(setProducts);
  }, [active]);

  const onSelect = (id) => {
    if (id === "all") setParams({}); else setParams({ category: id });
  };

  return (
    <div className="pb-24 md:pb-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-8">
        <h1 className="font-serif text-4xl text-[#2D0A22]">Shop</h1>
        <p className="text-[#8E6377] mt-1">Explore all our handcrafted crochet blooms.</p>
      </div>
      <div className="max-w-6xl mx-auto py-4">
        <CategoryChips categories={categories} active={active} onSelect={onSelect} />
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {categories.find(c => c.id === active)?.coming_soon ? (
          <div className="rounded-3xl bg-gradient-to-br from-[#FCE4EC] to-[#F8BBD0] p-10 text-center">
            <div className="text-5xl mb-3">🌷</div>
            <p className="font-serif text-2xl text-[#2D0A22]">Coming Soon</p>
            <p className="text-sm text-[#8E6377] mt-2 max-w-md mx-auto">
              We're stitching up something beautiful in this collection. Check back soon!
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-testid="shop-grid">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
        {products.length === 0 && !categories.find(c => c.id === active)?.coming_soon && (
          <p className="text-center text-[#8E6377] py-16">No products in this category yet.</p>
        )}
      </div>
    </div>
  );
};
